import { useMutation } from '@tanstack/react-query';
import { updateAnalytics } from '@/lib/api/settings';
import type { AnalyticsFormData } from '@/features/settings/validations/externalAnalytics';
import { queryClient } from '@/queries';
import { QUERY_KEYS } from '@/lib/constants';

export const useExternalAnalytics = () => {
    const { mutateAsync, isPending } = useMutation({
        mutationFn: (data: AnalyticsFormData) => updateAnalytics(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER] });
        },
    });

    return { mutateAsync, isPending };
};
